module.exports = __webpack_public_path__ + "static/media/strip-owl-desk.820eb2fb.svg";